export type DeviceType =
  | 'WEB'
  | 'WEBVIEW'
  | 'ANDROID_TV'
  | 'SMART_TV';

export function getDeviceType(): DeviceType {
  const ua = navigator.userAgent.toLowerCase();

  // Android TV
  if (ua.includes('android') && ua.includes('tv')) {
    return 'ANDROID_TV';
  }

  // Smart TVs (Samsung, LG, etc.)
  if (
    ua.includes('smart-tv') ||
    ua.includes('tizen') ||
    ua.includes('webos')
  ) {
    return 'SMART_TV';
  }

  // Mobile WebView (Android / iOS)
  if (
    (ua.includes('wv') || ua.includes('webview')) ||
    (ua.includes('iphone') && !ua.includes('safari'))
  ) {
    return 'WEBVIEW';
  }

  // Default browser
  return 'WEB';
}